<template>
  <v-container fluid class="px-md-1" style="padding-top: 100px;">
    <div v-if="show == true" id="cargando" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
      <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-card>
      <v-card-title class="pa-5 pb-3 primary">
        <v-icon class="pr-3" color="white">mdi-magnify</v-icon>
        <p style="color: white">Búsqueda General</p>
      </v-card-title>
      <v-card-text>
        <div v-if="showtable">
          <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions" :params="displayInputs"
            :order="[[0, 'asc']]" @apiDT="apiDT = $event"></DataTable>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import LocalStorage from '@/utils/managerLocalStorage.js';

    export default {
        title() {
            return this.$route.meta.title
        },
  components: {
    DataTable
  },
  data: function () {
    return {
      reportes: [],
      paginacion: [20, 50, 100],
      show: false,
      mostrarlistado: false,
      /////////
      urlListado: "Busqueda/BusquedaPorReporte",
      columns: [
        { name: 'nrreporte', data: 'nrreporte', title: "Reporte", formatter: [this, "detalleReporte"], },
        { name: 'svfhreporte', data: 'svfhreporte', title: "Fecha del Reporte" },
        { name: 'ainombre', data: 'ainombre', title: "Asistencia" },
        { name: 'clnombre', data: 'clnombre', title: "Cliente" },
        { name: 'flnomcomp', data: 'flnomcomp', title: "Flotilla" },
        { name: 'lonombre', data: 'lonombre', title: "Localidad" },
        { name: 'prnombre', data: 'prnombre', title: "Proveedor" },
        { name: 'supervisoria', data: 'supervisoria', title: "Supervisoria" },
        { name: "gerencia", data: "gerencia", title: "Gerencia" }
      ],
      displayInputs: {
        nrreporte: 0,
      },
      formatterActions: [
        { click: [this, "BuscarReporte"] },
      ],
      showtable: false,
      //historial: [],
    };
  },
  props: [],
  computed: {
    ...mapState({ drawer: state => state.drawer }),
    ...mapState(['domain', 'informationPage']),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    }
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    detalleReporte(datos) {
      if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5 || datos.aiclave == 26 || datos.aiclave == 27)) {
        return `<button data-action="0" data-params="${datos.nrreporte}" class="dt-formatterAction ma-1 reporteindice">${datos.nrreporte}-${datos.svindice}</span></button>`;
      } else {
        return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
      }
    },
    async BuscarReporte(params, item, fila) {
      let datos, nuevo, icono, url;
      let reporte = {
        nrreporte: item.nrreporte,
        svindice: item.svindice,
        aiclave: item.aiclave,
        svfhconclusion: item.svfhconclusion
      };

      if (item.aiclave != 26) {
        var ver = 0;
        let formData = new FormData();
        formData.append("nrreporte", item.nrreporte);
        formData.append("svindice", item.svindice);
        formData.append("uslogin", MetodosGenerales.ObtenerUserName());
        await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
          ver = data;
        });

        if (ver == 0) {
          this.$router.push({ name: `${"DatosIncompletos"}` });
        }
        else {
          await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
          this.$router.push({ name: `${"Asistencias"}` });
        }
      }
      else {
        await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
        this.$router.push({ name: `${"Asistencias"}` });
      }
    },
  },
  async mounted() {
    this.showtable = false;
    let reporte = this.$route.params.data;
    if (typeof reporte !== 'undefined') {
      if (reporte != 0) {
        this.showtable = true;
        this.displayInputs = {
          nrreporte: reporte,
        };
      }
    }
    this.$root.$on('busquedaReporte', data => {
      if (data != 0) {
        this.showtable = true;
        this.displayInputs = {
          nrreporte: data,
        };
      }
    })
  },
};
</script>
<style>
.reporteindice {
  color: var(--v-anchor-base);

}
</style>